import { useTranslations } from '@dora/vivian';
import * as Preact from 'preact';
import * as Hooks from 'preact/hooks';
import { useEffect } from 'preact/hooks';
import { validLocales } from '../assets/locales';
import { AppControlContext, useAppControl } from '../contexts/appControl';
import { useParentApi } from '../hooks/useParentApi';
import { setLogLevel } from '../store/middleware/log';
import { useInitialiseSentry } from '../store/middleware/sentry';
import { initialiseSkuDataCollection } from '../store/middleware/skuDataCollection';
import { initialiseTracking } from '../store/middleware/track';
import { useSelector } from '../store/redux';
import * as Selectors from '../store/selectors';

import { initialiseClientTracking } from '../store/middleware/clientTrack';
import * as ErrorPage from './error';
import * as Explore from './explore';
import * as ModularConfiguration from './modularConfiguration';
import * as Root from './root';

export function App(_props: {}) {
    const api = useParentApi();
    const appControl = useAppControl(api.closeApp, api.enhanceCloseApp);

    const { setLang } = useTranslations();

    const logLevel = useSelector(Selectors.Core.logLevel);
    const locale = useSelector(Selectors.Core.locale);

    useEffect(() => {
        setLogLevel(logLevel);
    }, [logLevel]);

    initialiseTracking(api.trackEvent);

    if (api.trackClientEvent) {
        initialiseClientTracking(api.trackClientEvent);
    }

    initialiseSkuDataCollection(api.skuDataEvent);

    useInitialiseSentry();
    Hooks.useEffect(() => {
        if (locale !== undefined && validLocales.includes(locale)) {
            setLang(locale);
        }
    }, [locale]);

    const initialisation = useSelector(Selectors.Initialisation.initialisation);

    let app;
    switch (initialisation.state) {
        case 'idle':
            app = <Root.Component />;
            break;
        case 'error':
            app = <ErrorPage.Component />;
            break;
        case 'inspiration':
        case 'configuration':
            app = <Explore.Component addToBasket={api.addToBasket} />;
            break;
        case 'modular':
            app = (
                <ModularConfiguration.Component
                    configuratorId={initialisation.configuratorId}
                    addToBasket={api.addToBasket}
                />
            );
            break;
    }

    return <AppControlContext.Provider value={appControl}>{app}</AppControlContext.Provider>;
}
